/** Clases de una fila del menú de perfil (perfil, idioma, tema, cerrar sesión). */
export const menuRow = (isDarkMode: boolean) =>
  `w-full h-9 px-2.5 rounded-lg flex items-center gap-2.5 text-left text-[14px] transition-colors duration-150 ${
    isDarkMode ? "text-gray-200 hover:bg-white/[0.06]" : "text-gray-700 hover:bg-black/[0.04]"
  }`;
/** Íconos grises: el color se reserva para lo que significa algo. */
export const menuIcon = (isDarkMode: boolean) => `text-[16px] ${isDarkMode ? "text-gray-400" : "text-gray-500"}`;
